import React from "react";

import makeStyles from '@mui/styles/makeStyles';
import { Participant } from "twilio-video";

import useParticipantNetworkQualityLevel from "../hooks/useParticipantNetworkQualityLevel/useParticipantNetworkQualityLevel";

const useStyles = makeStyles({
  outerContainer: {
    width: "30px",
    height: "30px",
    padding: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255, 255, 255, 0.7)",
    backdropFilter: "blur(4px)",
    borderRadius: "8px",
  },
  innerContainer: {
    display: "flex",
    alignItems: "flex-end",
    "& div": {
      width: "2px",
      marginRight: "3px",
      borderRadius: "20px",
    },
  },
});

const STEP = 3;
const BARS_ARRAY = [0, 1, 2];

export default function NetworkQualityLevel({
  participant,
  isLocalMainParticipant,
}: {
  participant: Participant;
  isLocalMainParticipant: boolean;
}) {
  const classes = useStyles();
  let networkQualityLevel = useParticipantNetworkQualityLevel(participant);

  if (isLocalMainParticipant) {
    networkQualityLevel = 5;
  }

  const normalizeNetworkQualityValue = () => {
    switch (networkQualityLevel) {
      case 0:
      case 1:
        return 1;
      case 2:
      case 3:
        return 2;
      case 4:
      case 5:
        return 3;
      default:
        return 1;
    }
  };

  return (
    <div className={classes.outerContainer}>
      <div className={classes.innerContainer}>
        {BARS_ARRAY.map((level) => (
          <div
            key={level}
            style={{
              height: `${STEP * (level + 2)}px`,
              background: normalizeNetworkQualityValue() > level ? "#475467" : "#FFF",
            }}
          />
        ))}
      </div>
    </div>
  );
}
